// Ported verbatim from specter-1 ui/packages/app/src/screens/Research.tsx:89-102.
// The "don't propagate to ancestor scrollers" behavior is the load-bearing detail:
// Element.scrollIntoView would move the page scroller too and yank the reader
// away from what they were reading. We constrain the scroll to one container.

export function scrollWithinRail(container: HTMLElement, target: HTMLElement): void {
  const cRect = container.getBoundingClientRect();
  const tRect = target.getBoundingClientRect();
  const margin = 12;
  let nextTop = container.scrollTop;
  if (tRect.top < cRect.top + margin) {
    nextTop -= cRect.top + margin - tRect.top;
  } else if (tRect.bottom > cRect.bottom - margin) {
    nextTop += tRect.bottom - (cRect.bottom - margin);
  } else {
    return;
  }
  container.scrollTo({ top: nextTop, behavior: "smooth" });
}
